<app-view-item *ngIf="disabled" [text]="selected?.code" [tabindex]="tabindex"></app-view-item>
<div class="ar-cate-select-container" *ngIf="!disabled">
  <nz-select #selector nzShowSearch nzServerSearch [nzAllowClear]="true" [nzBackdrop]="addBackdrop"
    [nzFilterOption]="nzFilterOption" (nzOnSearch)="search($event, 20)" (nzOpenChange)="onDropdownOpenChange($event)"
    (nzScrollToBottom)="loadMore()" [nzCustomTemplate]="displayTpl" [(ngModel)]="value"
    (keydown)="handleKeyDown($event)" (click)="handleClick($event)"
    (ngModelChange)="valueChanged($event)" [nzDropdownMatchSelectWidth]="false" nzDropdownClassName="dropdownSelect"
    [nzBorderless]="borderless" [nzDropdownRender]="null" [tabindex]="tabindex" class="width-100">
    <ng-template #displayTpl let-selected>
      {{ selected.nzLabel }}
    </ng-template>

    <!-- Custom Add New Button at top -->
    <nz-option *ngIf="!searching && showAddNewButton" [nzValue]="''" nzCustomContent>
      <div class="text-center" *ngIf="!this.NotShowInReport">
        <button type="button" nz-button nzType="primary" class="add-new-button" (click)="$event.stopPropagation(); onAddNewClick($event)">
          <span nz-icon nzType="plus"></span>
          {{ storedInstantData ? ' Add New \''+ storedInstantData +'\'' : ' Add New' }}
        </button>
      </div>
    </nz-option>

    <ng-container *ngFor="let o of list">
      <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="o.code" nzCustomContent>
        <span>{{ o.code }}</span>
      </nz-option>
    </ng-container>
  </nz-select>

  <!-- Inline Add Panel -->
  <app-inline-add-panel #inlineAddPanel [config]="categoryConfig" [visible]="showInlineAddPanel"
    [initialData]="inlineDefaults" (itemCreated)="onCategoryCreated($event)" (cancelled)="onCategoryCancelled()"
    (visibleChange)="showInlineAddPanel = $event" (moreDetails)="onCategoryMoreDetails()"
    (fieldChange)="onFieldChange($event)">
  </app-inline-add-panel>
</div>